import { Collapse } from 'antd'
import styled from 'styled-components'

export const StyledCollapse = styled(Collapse)`
  background-color: ${({ theme }) => theme.colors.light};

  .ant-collapse-header {
    align-items: center !important;
    &-text {
      font-size: 20px;
      font-weight: bold;
    }
  }
`
